import { CompositeFilterDisplayMode, CompositeFilterProps } from '@vista-digital/occ-ui'
import {
    defaultCompositeFilterConfigFilm,
    defaultCompositeFilterConfigShowtime,
} from '@vista-digital/occ-ui/src/lib/components/composite-filter/types/config'
import {
    defaultCompositeFilterPropsFilm,
    defaultCompositeFilterPropsShowtime,
} from '@vista-digital/occ-ui/src/lib/components/composite-filter/types/props'
import { filterConfigFilm, filterConfigShowtime } from '../omniFilter/props'

import { CompositeFilterPropsApi } from './models'
import { FilterType } from '@vista-digital/occ-domain'
import { OmniFilterModes } from '../'

export interface CompositeFilterPropsFromCms {
    filterId: string
    filterMode: OmniFilterModes
    displayText: CompositeFilterPropsApi
}

export function getCompositeFilterProps(props: CompositeFilterPropsFromCms, filterCount: number): CompositeFilterProps {
    const { filterId, displayText, filterMode } = props

    const filtersAppliedMessage = props.displayText.counterLabel
        ? props.displayText.counterLabel.replace('${count}', filterCount.toString())
        : filterCount.toString()

    const modalButtonLabel: string = filterCount > 0 ? filtersAppliedMessage : props.displayText.modalTriggerButtonLabel

    const filmProps: CompositeFilterProps = {
        ...defaultCompositeFilterPropsFilm,
        filterId: filterId,
        displayText: {
            ...displayText,
            modalTriggerButtonLabel: modalButtonLabel,
            resultCountMessage: displayText.resultCountFilmsMessage
        },
        config: {
            ...defaultCompositeFilterConfigFilm,
            displayMode: CompositeFilterDisplayMode.Modal,
            filterType: FilterType.Film,
            filters: filterConfigFilm,
        },
        assets: {
            filterModalButtonIconName: 'icon-filter'
        }
    }

    const showtimeProps: CompositeFilterProps = {
        ...defaultCompositeFilterPropsShowtime,
        filterId: filterId,
        displayText: {
            ...displayText,
            modalTriggerButtonLabel: modalButtonLabel,
            resultCountMessage: displayText.resultCountShowtimesMessage
        },
        config: {
            ...defaultCompositeFilterConfigShowtime,
            displayMode: CompositeFilterDisplayMode.Modal,
            filterType: FilterType.Showtime,
            filters: filterConfigShowtime,
        },
        assets: {
            filterModalButtonIconName: 'icon-filter'
        }
    }

    return filterMode == OmniFilterModes.Film ? filmProps : showtimeProps
}
